import LogoutIcon from "../IconsCode/LogoutIcon";
import ItemSideMenu from "./SubSideMenu/ItemSideMenu";

function SideMenu({ activeTab, setActiveTab, openModal }) {
    return (
        <div className="w-1/6 h-screen flex flex-col justify-between items-end">
            <div>
                <div className="flex flex-row-reverse items-center justify-center h-20">
                    <img src="/image/Logo.png" className="w-10" />
                    <p className="t-purpleDark font-extrabold mr-2">پنل مدیریت بوستان</p>
                </div>
                <div className="flex flex-row-reverse items-center bg-white rounded-lg mx-10 p-2 mt-5 mb-12">
                    <img src="/image/icon/userIcon.png" className="w-10" />
                    <p className="text-sm mr-2">نام کاربر</p>
                </div>

                {/* <ItemSideMenu text="مدیریت کانال ها" num={0} activeTab={activeTab} onClick={setActiveTab} />
                <ItemSideMenu text="مدیریت محتوای آزاد" num={1} activeTab={activeTab} onClick={setActiveTab} /> */}
                <ItemSideMenu text="سازمان ها" num={2} activeTab={activeTab} onClick={setActiveTab} />
                <ItemSideMenu text="مدیریت برندینگ" num={4} activeTab={activeTab} onClick={setActiveTab} />
                {/* <ItemSideMenu text="کاربران" num={3} activeTab={activeTab} onClick={setActiveTab} /> */}
            </div>
            <div onClick={() => openModal(true)}
                className="mb-16 mx-4 flex flex-row-reverse items-center mr-14 hover:cursor-pointer w-24">
                <LogoutIcon width={28} height={28} fill="#4355B9" />
                <p className="t-grayDark text-sm mr-2">خروج</p>
            </div>
        </div>
    )
}
export default SideMenu;